/**
 * iframe-modal-dialog.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

export interface URLContext
{
  url : string;
  title : string;
}

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      {{title}}
    </h4>
  </div>
  <div class="modal-body">
    <iframe [name]="title" [src]="url" match-height></iframe>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.close()">
      Close
    </button>
  </div>
  `,
  styles: [
    `iframe {
      width: 100%;
      min-height: 350px;
      border: none;
    }
    .modal-body {
      padding 0px;
    }`
  ]
})
export class IframeModalComponent implements ModalComponent<URLContext>
{
  public title : string;

  public url : SafeResourceUrl;

  public constructor (
    public dialog : DialogRef<URLContext>,
    private sanitizer : DomSanitizer
  )
  {
    this.title = dialog.context.title;
    this.url = sanitizer.bypassSecurityTrustResourceUrl(dialog.context.url);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/iframe-modal-dialog.component.ts